module.exports = __webpack_public_path__ + "img/02.1b11980b.png";